var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 926,
    viewBox: "0 0 428 926",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_266)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 926,
    fill: "url(#paint0_linear_87_266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68113 640.979L222.305 947.131H-49L6.68113 640.979Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68103 640.979L95.0801 757.213L21.0575 717.777L-21.2415 792.498L6.68103 640.979Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.195 503.99L328.577 940.385H14.9167L120.195 503.99Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.873 497.763L161.172 574.56L221.977 699.096L146.632 626.45L134.736 715.701L118.873 653.433L67.322 721.928L118.873 497.763Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.563 653.433L417.248 947.131H156.246L384.563 653.433Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.563 653.433L400.425 784.196L367.379 721.928L311.201 744.76L384.563 653.433Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.667 367L348.152 947.131H87.1492L257.667 367Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.667 367L291.409 582.862L257.667 526.821L235.195 582.862V512.292L190.252 595.316L257.667 367Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.804 692.869L511.46 948.168H310.54L441.804 692.869Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.804 692.869L467.839 787.309L441.804 734.382L398.442 777.969L441.804 692.869Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.701 753.062L357.388 912.883H245.77L368.701 753.062Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.241 611.921L327.724 912.883H245.77V732.306L268.241 611.921Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.721 777.969L467.839 912.883H329.046L419.721 777.969Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4136 755.138L48.8159 827.784L199.506 917.035L7.83911 906.657L18.4136 755.138Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68113 640.979L222.305 947.131H-49L6.68113 640.979Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68103 640.979L95.0801 757.213L21.0575 717.777L-21.2415 792.498L6.68103 640.979Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.195 503.99L328.577 940.385H14.9167L120.195 503.99Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.873 497.763L161.172 574.56L221.977 699.096L146.632 626.45L134.736 715.701L118.873 653.433L67.322 721.928L118.873 497.763Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.563 653.433L417.248 947.131H156.246L384.563 653.433Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.563 653.433L400.425 784.196L367.379 721.928L311.201 744.76L384.563 653.433Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.667 367L348.152 947.131H87.1492L257.667 367Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.667 367L291.409 582.862L257.667 526.821L235.195 582.862V512.292L190.252 595.316L257.667 367Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.804 692.869L511.46 948.168H310.54L441.804 692.869Z",
    fill: "#4C1D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.804 692.869L467.839 787.309L441.804 734.382L398.442 777.969L441.804 692.869Z",
    fill: "#F5F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.701 753.062L357.388 912.883H245.77L368.701 753.062Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.241 611.921L327.724 912.883H245.77V732.306L268.241 611.921Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.721 777.969L467.839 912.883H329.046L419.721 777.969Z",
    fill: "#5B21B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4136 755.138L48.8159 827.784L199.506 917.035L7.83911 906.657L18.4136 755.138Z",
    fill: "#5B21B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_266",
    x1: 214,
    y1: 0,
    x2: 214,
    y2: 926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ACE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 926,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.664aa2fafda931df61832029663a2a13.svg";
export { ForwardRef as ReactComponent };